import React from 'react';
import Profile from '../components/Profile/Profile';

export default function MyProfile() {
  return (
    <Profile />
  );
}
